import { render, staticRenderFns } from "./KycPendingModal.vue?vue&type=template&id=08a743af"
import script from "./KycPendingModal.vue?vue&type=script&lang=js"
export * from "./KycPendingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports